const queryGraphql = async (queryString: string, variablesObj?: any): Promise<any> => {
	try {
		const response = await fetch(`${process.env.REACT_APP_HOST_DOMAIN}/api/graphql`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			credentials: "include",
			body: JSON.stringify({
				query: queryString,
				variables: variablesObj ? variablesObj : null,
			}),
		});

		const result = await response.json();
		let data = result.data;

		if (result.error) {
			throw new Error(result.error.message);
		}
		if (!data) {
			throw new Error("API call returned no content");
		}
		return data;
	} catch (error: any) {
		console.log(error);
	}
};

export default queryGraphql;
